module.exports = __webpack_public_path__ + "img/ic-4.899352d.svg";